import * as React from "react";

import {
  CollaborationBarContext,
  CollaborationMode,
} from "./CollaborationBarContext";
import { CollaborationBarStorage } from "./collaborationBarStorage";

export function CollaborationBarProvider({
  children,
}: React.PropsWithChildren) {
  const [activeMode, setActiveModeState] =
    React.useState<CollaborationMode | null>(() => {
      return CollaborationBarStorage.getActiveMode();
    });

  const setActiveMode = React.useCallback((mode: CollaborationMode | null) => {
    setActiveModeState(mode);
    CollaborationBarStorage.setActiveMode(mode);
  }, []);

  const close = React.useCallback(() => {
    setActiveMode(null);
  }, [setActiveMode]);

  return (
    <CollaborationBarContext.Provider
      value={{
        isOpen: activeMode !== null,
        activeMode,
        setActiveMode,
        close,
      }}
    >
      {children}
    </CollaborationBarContext.Provider>
  );
}
